import Cookies from 'js-cookie'

const api_link = "https://api2.mypacome-manager.fr"

export function fileInfo(file) {
    if (!file) return { fichier: 'absent' }
    return {
        nom: file.name,
        type: file.type || '(vide)',
        taille: file.size,
        objet: file instanceof File ? 'File' : 'Blob',
    }
}

export function imageLog(msg, meta) {
    try {
        const cookie = Cookies.get('MyPacome-Concierge')
        const token = cookie ? JSON.parse(cookie).token : null
        if (!token) return
        fetch(api_link + '/logs/client/cm', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', token: token },
            keepalive: true,
            body: JSON.stringify({
                entries: [{ level: 'info', msg: msg, url: window.location.pathname, meta: meta }],
            }),
        }).catch(() => null)
    } catch (err) {
    }
}
